export const PACKAGE_SEARCH = 'package_search';
export const ERROR = 'error';
export const ADD_ORG = 'add_org'
export const ADD_GROUP = 'add_group'
export const ADD_TAG = 'add_tag'
